module.exports = __webpack_public_path__ + "img/icon-truck.aa1dcf6d.svg";